/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { faker } from '@faker-js/faker/locale/en';
import { ENTITY_TYPES } from '../../../constants/Repository.constants';
import { JobContext } from '../JobContext';

export const createMockJobContext = (partialRecord: Partial<JobContext> = {}): JobContext => {
  const environment: Record<string, string> = partialRecord.environment ?? {};

  if (!partialRecord.environment) {
    const numOfEnvVars = faker.number.int({ max: 5, min: 1 });
    for (let i = 0; i < numOfEnvVars; i++) {
      const key = faker.lorem.word(); // Generate a random key
      const value = faker.lorem.word(); // Generate a random value
      environment[key] = value;
    }
  }

  return {
    contextName: faker.lorem.word(),
    description: faker.lorem.words(),
    environment,
    type: ENTITY_TYPES.context,
    ...partialRecord,
  };
};

export const createMockJobContexts = (size?: number): Array<JobContext> => {
  const randomSize = size ?? faker.number.int({ max: 3, min: 1 });
  return Array.from({ length: randomSize }).map(() => createMockJobContext());
};
